(function () {
  'use strict';

  var SESSION_KEY = 'roi_popup_seen';
  var overlay = document.getElementById('email-popup-overlay');
  if (!overlay) return;

  // --- Vérification localStorage permanent ---
  function hasSeenThisSession() {
    try { return localStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }

  function markSeenThisSession() {
    try { localStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  // --- Open / Close ---
  function openPopup() {
    overlay.classList.add('email-popup-overlay--open');
    document.body.style.overflow = 'hidden';
    document.getElementById('email-popup-close').focus();
    markSeenThisSession();
  }

  function closePopup() {
    overlay.classList.remove('email-popup-overlay--open');
    document.body.style.overflow = '';
  }

  // --- Show success state ---
  function showSuccess() {
    document.getElementById('email-popup-form-view').style.display = 'none';
    document.getElementById('email-popup-success-view').style.display = 'block';
  }

  // --- AJAX form submission via bouton (type=button, jamais de submit natif) ---
  var submitBtn = document.getElementById('email-popup-submit');
  var form = document.getElementById('EmailPopupForm') || document.querySelector('#email-popup-form-view form');

  if (submitBtn && form) {
    submitBtn.addEventListener('click', function () {
      var errorEl = document.getElementById('email-popup-error');
      var emailInput = document.getElementById('EmailPopupInput');

      if (!emailInput || !emailInput.value) return;

      submitBtn.disabled = true;
      submitBtn.textContent = '...';
      errorEl.style.display = 'none';

      var formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
        redirect: 'manual',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function () {
          showSuccess();
        })
        .catch(function () {
          submitBtn.disabled = false;
          submitBtn.textContent = 'J\'en profite';
          errorEl.textContent = 'Une erreur est survenue, réessaie.';
          errorEl.style.display = 'block';
        });
    });
  }

  // --- Promo code copy ---
  var promoCodeEl = document.getElementById('email-popup-promo-code');
  var copyHint = document.getElementById('email-popup-copy-hint');
  if (promoCodeEl) {
    promoCodeEl.addEventListener('click', function () {
      try {
        navigator.clipboard.writeText(promoCodeEl.textContent.trim()).then(function () {
          if (copyHint) copyHint.textContent = 'Copié !';
          setTimeout(function () {
            if (copyHint) copyHint.textContent = 'Clique pour copier le code';
          }, 2000);
        });
      } catch (e) {}
    });
  }

  // --- Close triggers ---
  document.getElementById('email-popup-close').addEventListener('click', closePopup);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('email-popup-overlay--open')) {
      closePopup();
    }
  });

  // --- Init ---
  if (!hasSeenThisSession()) {
    setTimeout(openPopup, 500);
  }
})();
